import { Action } from 'redux';
import { RecommendationType } from '../../spaces/RecommendationSpace/RecommendationTypeDropdown';
import { ChangeRecommendationType } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface ChangeRecommendationTypeAction extends Action {
  recommendationType: RecommendationType;
}

export function changeRecommendationType(recommendationType: RecommendationType): ChangeRecommendationTypeAction {
  return {
    type: ChangeRecommendationType,
    recommendationType
  };
}

export const isChangeRecommendationTypeAction = isActionFactory<ChangeRecommendationTypeAction>(ChangeRecommendationType);
